// extracted by mini-css-extract-plugin
export default {"roles":"Roles_roles__C5vhT"};